// extracted by mini-css-extract-plugin
module.exports = {"BigMedia":"BigMedia_BigMedia__R1NN5","innerContainer":"BigMedia_innerContainer__KDl4b","inner":"BigMedia_inner__Tauji","media":"BigMedia_media__H_o8t"};